import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { BOX_IMAGE, CHECKOUT_URL, offerIncludes } from '../data/atlas';
export function Offer() {
  return <section id="offer" className="scroll-mt-2 bg-navy px-4 py-6 sm:py-8" data-id="element-100" data-mp="1mo22e5uxyvgv">
      <div className="mx-auto max-w-2xl" data-id="element-101" data-mp="1mpd5e3gkbz6x">
        <p className="text-center text-[10px] font-extrabold uppercase tracking-[0.2em] text-teal sm:text-xs" data-id="element-102" data-mp="1hph1e47v87rd">
          Special launch offer
        </p>
        <h2 className="mt-1 text-center text-2xl leading-none text-white sm:text-3xl" data-id="element-103" data-mp="u0obaodxcu4o">
          🦷 PROSTHODONTICS VISUAL ATLAS™
        </h2>
        <p className="mt-1 text-center text-xs font-extrabold uppercase tracking-wide text-ice sm:text-sm" data-id="element-104" data-mp="13xaul8qlrd4l">
          The complete visual study system for dental students
        </p>

        <a href={CHECKOUT_URL} className="mt-3 block" data-id="element-105" data-mp="2fbofq5tz1egx">
          <img src={BOX_IMAGE} alt="PROSTHODONTICS VISUAL ATLAS™ complete 6-in-1 system" className="mx-auto w-full max-w-[220px] drop-shadow-2xl transition-transform duration-200 ease-soft hover:scale-[1.02]" data-id="element-106" data-mp="2feano6krxvzo" />
        </a>

        <div className="mt-4 rounded-xl border-4 border-teal bg-white p-4 text-center shadow-2xl sm:p-5" data-id="element-107" data-mp="ui0kybf5l985">
          <p className="text-sm font-extrabold uppercase tracking-wide text-navy" data-id="element-108" data-mp="zjpufmmq9eu4">
            Complete 6-in-1 Prosthodontics Visual System
          </p>

          <ul className="mt-3 grid gap-1.5 text-left sm:grid-cols-2" data-id="element-109" data-mp="6tzink8kip16">
            {offerIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm font-semibold leading-snug text-navy" data-id="element-110" data-mp="bs10k1u9cib2">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-111" data-mp="fskvqzv9tbuk" />
                {item}
              </li>)}
          </ul>

          <div className="mt-4 flex items-baseline justify-center gap-2" data-id="element-112" data-mp="3oa7iiswaz5j3">
            <span className="text-lg font-bold text-slate2 line-through" data-id="element-113" data-mp="3o84jxkh3442r">$97</span>
            <span className="font-display text-5xl leading-none text-navy sm:text-6xl" data-id="element-114" data-mp="ve5z02hhtbpl">
              $27
            </span>
          </div>

          <p className="mt-1 text-xs font-extrabold uppercase tracking-wide text-alert" data-id="element-115" data-mp="155agp9yjzao4">
            🔥 Get PROSTHODONTICS VISUAL ATLAS™ today
          </p>

          <CTAButton className="mt-3" data-id="element-116" data-mp="106z44rgvim27">🦷 YES! I WANT THE COMPLETE SYSTEM</CTAButton>

          <p className="mt-2 text-xs font-bold text-slate2" data-id="element-117" data-mp="cho3rb3fqtol">
            Immediate Digital Access · 🛡️ 14-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}